import http from '@/libs/http'

export function loadProxy (queryModel) {
  return http.get('crm/system/listsaler', { params: queryModel })
}

export function updateUiPrivilege (userId, codes) {
  return http.put('crm/privilege/uiupdate', { userId, uis: codes })
}

export function UnlockPassport (queryData) {
  return http.post('zpchelper/unlock/', queryData)
}

export function SplitOrderItem (queryData) {
  return http.post('zpchelper/splitorder/', queryData)
}

export function EpcOrderPay (queryData) {
  return http.post('zpchelper/epcorderpay/', queryData)
}
